module.exports = __webpack_public_path__ + "img/16_lisa_d.e7924555.png";